const mapElements = document.querySelectorAll('.purchase-process__thank-you__map-init');
const mapPinsElements = document.querySelectorAll('.purchase-process__thank-you__map-pin');

function initialize(el, mapLat, mapLng, mapZoom) {
  const mapOptions = {
    zoom: Number(mapZoom),
    center: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
    mapTypeControl: false,
    fullscreenControl: false,
  };

  const map = new google.maps.Map(el, mapOptions);
  const infoWindow = new google.maps.InfoWindow({ disableAutoPan: true });
  const infoCard = document.querySelector('.infowindow-wrap');

  Array.prototype.forEach.call(mapPinsElements, (elm) => {
    const pinLat = elm.getAttribute('data-markerlat');
    const pinLng = elm.getAttribute('data-markerlng');
    const mapPinIcon = elm.getAttribute('data-marker');

    // eslint-disable-next-line no-unused-vars
    const marker = new google.maps.Marker({
      // eslint-disable-next-line object-shorthand
      map: map,
      position: new google.maps.LatLng(pinLat, pinLng),
      icon: mapPinIcon,
    });

    infoWindow.setContent(infoCard.innerHTML);
    infoWindow.open(map, marker);
  });
}

mapElements.forEach((el) => {
  const mapLat = el.getAttribute('data-lat');
  const mapLng = el.getAttribute('data-lng');
  const mapZoom = el.getAttribute('data-zoom');

  // eslint-disable-next-line no-unused-vars
  initialize(el, mapLat, mapLng, mapZoom);
});
